export type SectionCommitPayload = Record<
  string,
  Record<string, unknown>
>;

export function buildSectionCommitFormData(
  sections: SectionCommitPayload,
): FormData {
  const formData = new FormData();
  const payloadSections: SectionCommitPayload = {};

  Object.entries(sections).forEach(([sectionId, values]) => {
    const payload: Record<string, unknown> = {};
    Object.entries(values).forEach(([field, value]) => {
      if (value instanceof File || value instanceof Blob) {
        formData.append(`file__${sectionId}__${field}`, value);
      } else {
        payload[field] = value;
      }
    });
    payloadSections[sectionId] = payload;
  });

  formData.append('payload', JSON.stringify({ sections: payloadSections }));
  return formData;
}
